import React, {useEffect, useState, Suspense} from 'react';
import {decodeToken, useJwt} from "react-jwt";
import {useOktaAuth} from "@okta/okta-react";

import AppContext from "../Context/AppContext.react";
import {Switch} from "react-router-dom";

import TBNavbar from "../Components/Navigation/TBNavbar.react";
import Routes from "../Components/Navigation/Routing/Routes.react";



const BackOffice = () => {
  const { authState, oktaAuth } = useOktaAuth();
  window.authState = authState

  const [accessToken, setToken] = useState();
  const [tenant, setTenant] = useState({name: '', id: null});
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);


  const getMetaData = async () => {
    let user = authState.idToken.claims;
    const accessToken = authState.accessToken.accessToken
    setPermissions(authState.accessToken.claims.groups);
    setToken(accessToken);
    setUser(user);
    setLoading(false);
  }

  useEffect(() => {
    if (!authState.isPending && authState.isAuthenticated) {
      getMetaData();
    } else if (!authState.isPending && !authState.isAuthenticated){
      oktaAuth.signInWithRedirect()
    }
  }, [authState])

  // if(loading) {
  //   return (<div>Loading...</div>)
  // }

  return (
    <AppContext.Provider value={{token: accessToken, tenant: tenant, setTenant: setTenant, permissions: permissions, user: user}}>
      <div className="App">
        <TBNavbar userName={user?.name} />
        <Switch>
          <Suspense fallback={<h1>Hi</h1>}>
            <Routes />
          </Suspense>
        </Switch>
      </div>
    </AppContext.Provider>
  )
}

export default BackOffice;
